import React, { useState, useEffect } from "react";
import { Grid, Paper } from "@material-ui/core";
import { styled } from "@material-ui/styles";
import { IStyledArguments } from "../../types/styled-arguments";
// import ProgressBar from "../progress-bar";
import StepInitial from "./StepInitial";
import { useMutation, useQuery } from "@apollo/client";
import { gql } from "@apollo/client";
// import useAuthContext from "../../hooks/useAuthContext";
import { injectIntl } from "react-intl";
import Content from "../content";
import Link from "../link";
import Button from "../button";
import { ITeam } from "../../types";
import messages from "./PageAddLeague.intl";

export const ADD_LEAGUE = gql`
  mutation NewLeague(
    $name: String!
    $location: String!
    $startDate: String!
    $homeTeam: ID!
  ) {
    newLeague(
      input: {
        name: $name
        location: $location
        startDate: $startDate
        homeTeam: $homeTeam
      }
    ) {
      id
      name
      location
    }
  }
`;

const ALL_TEAMS = gql`
  query AllTeams {
    allTeams {
      id
      name
    }
  }
`;

const StyledActionLink = styled(Link)(({ theme }: IStyledArguments) => {
  return {
    ...theme.typography.caption,
    color: theme.palette.secondary.dark,
    textDecoration: "none",
    textTransform: "uppercase",
  };
});

const ButtonRow = styled("div")(({ theme }: IStyledArguments) => ({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  paddingTop: theme.spacing(2),
}));

const MessageSpace = styled("div")(({ theme }: IStyledArguments) => ({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  paddingTop: theme.spacing(2),
}));

const StyledPaper = styled(Paper)(({ theme }: IStyledArguments) => ({
  boxSizing: "border-box",
  padding: theme.spacing(4),
  marginBottom: theme.spacing(5),
  textAlign: "center",
  display: "flex",
  flexDirection: "column",
  margin: "0 auto",
  maxWidth: 630,
  [`@media (max-width: ${theme.breakpoints.values.md}px)`]: {
    boxShadow: "none",
  },
}));

interface IPageAddLeagueProps {
  id: string;
}

const PageAddLeague = injectIntl<IPageAddLeagueProps>(({ id, intl }) => {
  const { data: dataTeams } = useQuery(ALL_TEAMS);
  const [currentStep, setCurrentStep] = useState(1);
  // const [match, setMatch] = useState<IMatch>();
  const [addLeague, { data, loading }] = useMutation(ADD_LEAGUE);
  const [teams, setTeams] = useState<ITeam[]>();
  const handleCreateLeague = async (form: any) => {
    console.log("adding league...");
    console.log(form);
    addLeague({
      variables: {
        name: form.name,
        location: form.location,
        startDate: form.date,
        homeTeam: id,
      },
    });
  };

  useEffect(() => {
    if (loading) {
      return;
    }

    if (dataTeams) {
      console.log("data teams recieved: ", dataTeams);
      setTeams(dataTeams.allTeams);
    }

    if (!data) {
      return;
    } else {
      // setMatch(data.createMatch);
      setCurrentStep(2);
    }
  }, [data, dataTeams]);

  if (loading) {
    // TODO: LOADING SPINNER
    return (
      <Content>
        <p>LOADING</p>
      </Content>
    );
  }

  return (
    <Content>
      <Grid container spacing={0} justify="center" alignItems="center">
        <Grid item xs={12} md={6}>
          <StyledPaper>
            {/* <ProgressBar value={(currentStep / 2) * 100} /> */}
            {currentStep === 1 && (
              <StepInitial
                onGoNext={(values: any) => {
                  handleCreateLeague(values);
                }}
                // match={match}
                teams={teams}
              />
            )}
            {currentStep === 2 && (
              <Content>
                <svg
                  height="80px"
                  viewBox="-41 0 499 499.312"
                  width="80px"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                >
                  <linearGradient
                    id="a"
                    gradientUnits="userSpaceOnUse"
                    x1="208.156"
                    x2="208.156"
                    y1="499.312"
                    y2="-.0008"
                  >
                    <stop offset="0" stop-color="#FF5722" />
                    <stop offset="1" stop-color="#0bb1d3" />
                  </linearGradient>
                  <path
                    d="m291.691406 243.488281c3.054688-10.207031 8.023438-19.824219 14.703125-28.167969l2.121094-2.648437c7.503906-9.390625 11.640625-21.183594 11.640625-33.191406 0-17.816407-8.839844-34.34375-23.671875-44.234375l-8.113281-5.390625-32.214844 19.328125v-17.871094h-15.984375v-8c0-13.234375-10.769531-24-24-24h-8v-8c0-13.234375-10.769531-24-24-24h-14.015625l24.574219-32.753906-34.558594-34.558594-34.558594 34.558594 24.542969 32.753906h-13.984375c-13.230469 0-24 10.765625-24 24v8h-8c-13.230469 0-24 10.765625-24 24v8h-16.015625v17.871094l-32.214844-19.328125-8.121094 5.402343c-14.824218 9.878907-23.664062 26.40625-23.664062 44.222657 0 12.015625 4.136719 23.808593 11.640625 33.191406l2.128906 2.65625c11.75 14.695313 18.230469 33.152344 18.230469 51.984375 0 4.414062-3.585938 8-8 8-4.417969 0-8-3.585938-8-8v-8h-16v8c0 13.230469 10.769531 24 24 24s24-10.769531 24-24c0-22.457031-7.726562-44.472656-21.746094-61.976562l-2.117187-2.648438c-5.25-6.566406-8.136719-14.816406-8.136719-23.207031 0-12.320313 6.0625-23.777344 16.222656-30.703125l31.777344 19.0625v22.433594c0 55 23.222656 107.34375 63.769531 144.328124-1.136719 15.34375-10.042969 28.902344-23.976562 35.878907l-7.785157 3.894531-.007812 28.9375h-7.984375c-13.230469 0-24 10.765625-24 24v25.472656c-9.289063 3.3125-16 12.109375-16 22.527344v24h216v-2.335938c7.777344 1.488282 15.777344 2.335938 23.984375 2.335938 70.574219 0 128-57.425781 128-128 0-69.382812-55.527344-125.921875-124.464844-127.824219zm-131.519531-220.863281 13.441406 13.4375-13.449219 17.914062-13.433593-17.914062zm179.984375 404.6875-19.457031-25.9375 6.394531-31.941406 40.101562-13.371094 32.738282 19.648438c-.738282 18.753906-6.050782 36.304687-14.929688 51.609374h-44.847656zm-106.03125 16 8.648438 30.304688c-15.640626-6.960938-29.402344-17.371094-40.289063-30.304688zm2.03125-16h-44.847656c-8.816406-15.183594-14.113282-32.585938-14.914063-51.175781l40.121094-20.066407 32.640625 13.058594 6.457031 32.246094zm52-168c10.527344 0 20.671875 1.558594 30.335938 4.289062l-29.976563 24.933594-30.535156-24.984375c9.617187-2.6875 19.710937-4.238281 30.175781-4.238281zm-47.519531 10.726562 39.519531 32.34375v32.929688l-25.199219 18.902344-33-13.199219-20.34375-40.695313c10.519531-12.808593 23.871094-23.136718 39.023438-30.28125zm-49.382813 45.359376 14.167969 28.335937-28.394531 14.195313c1.847656-15.34375 6.808594-29.722657 14.226562-42.53125zm73.734375 51.289062 23.167969-17.375 23.167969 17.375-5.71875 28.625h-34.890625zm112.785157-22.925781 8.679687-26.058594c6.460937 11.808594 10.765625 24.9375 12.605469 38.824219zm-2.59375-42.808594-13.351563 40.039063-40.222656 13.40625-25.449219-19.085938v-32.3125l39.574219-32.929688c15.371093 7.25 28.867187 17.816407 39.449219 30.882813zm-87.246094-152.175781c10.167968 6.933594 16.222656 18.375 16.222656 30.703125 0 8.398437-2.886719 16.640625-8.144531 23.207031l-2.121094 2.640625c-9.046875 11.3125-15.34375 24.601563-18.757813 38.640625-9.871093 1-19.367187 3.246094-28.457031 6.367188 6.289063-19.34375 9.480469-39.464844 9.480469-60.0625v-22.433594zm-159.761719-57.464844c0-4.417969 3.585937-8 8-8h48c4.417969 0 8 3.582031 8 8v8h-64zm-32 32c0-4.417969 3.585937-8 8-8h112c4.417969 0 8 3.582031 8 8v8h-128zm-16.015625 66.960938v-42.960938h160v42.960938c0 23.910156-4.710938 47.117187-13.894531 69.078124-25.480469 14.144532-45.617188 36.726563-56.683594 63.960938h-30.375c-37.558594-33.976562-59.046875-82.296875-59.046875-133.039062zm32.015625 193.964843c17.367187-9.109375 28.902344-25.8125 31.441406-44.925781h20.757813c-2.65625 10.246094-4.214844 20.933594-4.214844 32 0 11.0625 1.558594 21.75 4.214844 32h-52.207032zm-24 35.074219h81.40625c4.722656 11.609375 11.082031 22.367188 18.816406 32h-108.222656v-24c0-4.417969 3.585937-8 8-8zm-24 64v-8c0-4.417969 3.585937-8 8-8h131.609375c6.917969 6.085938 14.429688 11.503906 22.550781 16zm197.039063-3.417969-12.277344-42.964843 19.222656-25.617188h40l19.214844 25.625-12.277344 42.964844c-8.640625 2.144531-17.632812 3.410156-26.9375 3.410156s-18.296875-1.265625-26.945312-3.417969zm72.320312-6.277343 8.65625-30.304688h31.640625c-10.894531 12.933594-24.65625 23.34375-40.296875 30.304688zm0 0"
                    fill="url(#a)"
                  />
                </svg>
                <MessageSpace>
                  {intl.formatMessage(messages.league)}{" "}
                  {intl.formatMessage(messages.created)}
                </MessageSpace>
                <ButtonRow>
                  <StyledActionLink to="/people/matches">
                    <Button>Ok</Button>
                  </StyledActionLink>
                </ButtonRow>
              </Content>
            )}
          </StyledPaper>
        </Grid>
      </Grid>
    </Content>
  );
});

export default PageAddLeague;
